
import { defineComponent, computed } from 'vue'

export default defineComponent({
  setup(props, { emit }) {
    const prevLabel = computed(() => '')
    const todayLabel = computed(() => '最新')
    const nextLabel = computed(() => '')

    const move = (tag: string) => {
      emit(tag)
    }

    return {
      prevLabel,
      todayLabel,
      nextLabel,
      move,
    }
  },
})
